import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import apiConfig from "@apiConfig";
import http from "@core/fetch";
import { useData } from "@hooks/useData";
import { routeNames } from "@core/routeNames";
import { components } from "@apiSchema";
import { ID } from "@models";

const REQUEST_TYPE: keyof typeof apiConfig = 'get category profiles';

export type ICategoryProfile = components["schemas"]["MtCategoryProfile"];

async function getCategoryProfiles(): Promise<ICategoryProfile[]> {
    try {
        return await http.get(REQUEST_TYPE) as ICategoryProfile[];
    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return [];
    }
}

export default function useCategoryProfile(id: ID) {
    const history = useHistory();
    const { data: profiles, isLoading } = useData<ICategoryProfile[]>([], getCategoryProfiles);
    const profile = useMemo(
        () => profiles.find(p => String(p.id) === String(id)),
        [profiles, id],
    );

    const shouldRedirect = !isLoading && !profile;

    useEffect(() => {
        if (shouldRedirect) history.replace(routeNames.error);
    }, [shouldRedirect, history]);

    return {
        data: profile,
        isLoading,
    };
}
